import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ListSingleFilter } from '@shared/modules/list/interfaces/list-single-filter.interface';
import { ListService } from '@shared/modules/list/services/list.service';
import { NgSelectExtensionDirective } from '@shared/directives/ng-select-extension.directive';

declare var $: any;

@Component({
  selector: 'list-single-filter-select-v2',
  templateUrl: './list-single-filter-select-v2.component.html'
})
export class ListSingleFilterSelectV2Component implements ListSingleFilter, AfterViewInit, OnChanges {
  @Input() form: UntypedFormGroup;
  @Input() control: UntypedFormControl;
  @Input() name: string;
  @Input() iconUrl: string;
  @Input() controlName: string;
  @Input() url: string;
  @Input() localItems: any[] = [];
  @Input() bindValue?: string = 'id';
  @Input() bindLabel?: string = 'text';
  @Input() searchGetParams?: string = 'query';
  @Input() valueTransform;
  @Input() selectedValueTransform;
  @Input() optionValueTransform?: (item: any) => { primary: string; secondary: string };
  @Input() optionTooltipTransform?: (item: any) => string;
  @Input() singleLineOption: boolean = false;
  @Input() translateLabelPrefix?: string;
  @Input() responseTransform?: Function;
  @Input() requiredIdUrl?: string;
  @Input() selectedUrl?: string;
  @Input() multiple: boolean = false;
  @Input() showSelectedCountForSingle: boolean = false;
  @Input() loading: boolean = false;
  @Input() sortByField?: string = 'id';

  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() selectedValues: EventEmitter<Array<{ id: any; name: string }>> = new EventEmitter();

  @ViewChild('select') select: NgSelectExtensionDirective;

  items: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['localItems'] && !this.url) {
      this.items = this.localItems || [];
      if (this.select) this.emitSelectedFormattedValues();
    }
  }

  constructor(
    public service: ListService,
    private changes: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    if (!this.url && this.localItems.length) {
      this.items = this.localItems;
      this.emitSelectedFormattedValues();
    }

    if (this.requiredIdUrl || this.selectedUrl) {
      setTimeout(() => {
        const controlValue = this.getControl().value;

        if (controlValue) {
          if (this.selectedUrl) {
            if (Array.isArray(controlValue)) {
              const params = controlValue
                .map((val) => `selectedValues[]=${encodeURIComponent(val)}`)
                .join('&');
              this.select.url = `${this.selectedUrl}?${params}`;
            } else {
              this.select.url = `${this.selectedUrl}?selectedValues=${encodeURIComponent(controlValue)}`;
            }
          } else if (this.requiredIdUrl) {
            this.select.url = `${this.requiredIdUrl}?requiredId=${controlValue}`;
          }
        } else {
          this.select.url = this.requiredIdUrl || this.selectedUrl;
        }
        this.select.getItems();
      });
    }
  }

  clear() {
    this.getControl().setValue(null);
    this.change.emit();
  }

  onChange() {
    this.change.emit();
    this.changes.detectChanges();
    this.emitSelectedFormattedValues();
  }

  open(e) {
    setTimeout(() => {
      const $dropdown = $('.ng-dropdown-panel');

      const bounds = $dropdown.get(0).getBoundingClientRect();
      const position = $dropdown.position();

      const diff = document.body.offsetWidth - (bounds.width + bounds.left);

      const left = diff < 0 ? diff - 30 : position.left;
      $dropdown.css({
        left: left + 'px'
      });
    });
  }

  getControl() {
    return this.control ? this.control : this.form.get(this.controlName);
  }

  handleItemsResponse(_items: any[]) {
    this.emitSelectedFormattedValues();
  }

  get isValue(): boolean {
    if (this.control) return this.control.value && this.control.value.toString().length;
    return this.form?.value[this.controlName] && this.form?.value[this.controlName].toString().length;
  }

  private emitSelectedFormattedValues() {
    setTimeout(() => {
      const values = this.select.select.selectedValues.map((item: any) => {
        return {
          id: this.selectedUrl ? item.value : item.id,
          name: this.valueTransform
            ? this.valueTransform(item)
            : this.select.getTranslatedLabel(item[this.bindLabel])
        };
      });
      this.selectedValues.emit(values);
    });
  }
}
